// Admin - Admin Payments
export const ADMIN_ALL_PAYMENTS = `project/payment/all_transactions`;
export const ADMIN_ALL_SUCCESSFUL_PAYMENTS = `project/payment/successful_transactions`;

// Admin - Project Assignment
export const ADMIN_ASSIGN_PROJECT = `admin/project-application/assign`;
export const ADMIN_WITHDRAW_ASSIGNMENT = `admin/project-application/withdraw_assignment`;

// Admin - Admin Actions
export const ADMIN_DRAFT_PROJECTS = `admin/project/drafts`;
export const ADMIN_PUBLISHED_PROJECTS = `admin/project/published`;
export const ADMIN_RUNNING_PROJECTS = `admin/project/started`;
export const ADMIN_COMPLETED_PROJECTS = `admin/project/completed`;
export const ADMIN_CANCELLED_PROJECTS = `admin/project/cancelled`;
export const ADMIN_DELETED_PROJECTS = `admin/project/deleted`;
export const ADMIN_GET_USER_PROJECTS = {
  USER_ID: userId => `admin/project/user/${userId}`,
};

// Admin - Admin Users
export const ADMIN_GET_ALL_USERS = `admin/users/all`;
export const ADMIN_DELETE_SELECTED_USER = {
  USER_ID: userId => `admin/users/delete/${userId}`,
};
